module.exports = __webpack_public_path__ + "img/big_11B07_red.ba0bf1b6.png";